import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/ask/point.png';
import _imports_1 from '@/assets/componentImg/addr_icon.png';
import _imports_2 from '@/assets/componentImg/tag_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-b2d891ea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "custom-indicator"
};
const _hoisted_2 = {
  class: "user-wrap"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = {
  key: 0,
  class: "point-wrap"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_7 = {
  class: "text-wrap"
};
const _hoisted_8 = {
  key: 2,
  class: "tag-wrap"
};
const _hoisted_9 = {
  key: 0,
  class: "item"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_11 = ["onClick"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_13 = {
  class: "comment-wrap"
};
const _hoisted_14 = {
  class: "title-wrap"
};
const _hoisted_15 = {
  class: "title"
};
import { onMounted } from 'vue';
import ua from '@/utils/platform';
import CPage from '@/views/CPage.vue';
import CommentType from '@/components/moment/switch-type.vue';
import LinkView from '@/components/moment/link-view.vue';
import AuthorProgressView from '@/components/moment/author-progress-view.vue';
import CPlayer from '@/components/moment/cplayer.vue';
import BottomCommentView from '@/components/moment/bottom-comment-view.vue';
import { getPostShareImg, copyTextToClipboard } from '@/utils/regular';
import composition from '@/composition';
import contentWrap from '@/components/ask/content-wrap.vue';
import CommentList from '@/components/moment/comment-list.vue';
import { gotByRoute, goToMainPage } from '@/utils/app';
export default {
  setup(__props) {
    const {
      ref,
      openApp,
      request,
      formatTime,
      getQueryString,
      CImage,
      openWebPage,
      store,
      wxShare,
      isIframe
    } = composition();
    const id = getQueryString().id;
    let durationStart = 0;

    if (!isIframe.value) {
      gotByRoute(`foshanplus://timeline/moment/detail?id=${id}`);
    }

    onMounted(() => {
      durationStart = new Date().getTime();

      if (ua.isAndroid && !isIframe.value) {
        setTimeout(() => {
          goToMainPage(); // closeWebView()
        }, 1500);
      }
    });

    window.onbeforeunload = function () {
      console.log('onbeforeunload---------------------------|||||||||||');
      pocPageLeave(1);
    };

    document.onvisibilitychange = function () {
      console.log('onvisibilitychange---------------------------|||||||||||');
      pocPageLeave(2);
    }; // 帖子详情


    const postItem = ref({});
    const shareDescList = {
      ASK: '问吧-有问题就会有答案',
      MOMENT: '友趣-分享我的趣味生活',
      12345: '全民拍-标记城市里的弊端',
      REPORT: '找记者-解决生活的麻烦事',
      NEIGHBOR: '友邻-分享我的社区新鲜事'
    }; // 频道

    const categories = ref([]);
    request.getPostDetail(id).then(res => {
      window.zmyCollectionOpenActivityH5(id);

      if (res.post.state == -2) {
        // 已删除
        _Dialog.alert({
          title: '提示',
          message: '该帖子已删除'
        });

        return;
      } else if (res.post.state != 1) {
        // 未通过
        _Dialog.alert({
          title: '提示',
          message: '该帖子正在审核中，请耐心等待，您可以复制链接分享给好友。',
          confirmButtonText: '复制链接',
          showCancelButton: true,
          cancelButtonText: '我知道了'
        }).then(() => {
          // on close
          copyTextToClipboard(location.href);
          alert('链接复制成功，请您分享给朋友。');
        });

        return;
      }

      store.state.post = res.post;
      postItem.value = res.post;
      categories.value = res.post.categories;
      wxShare(res.post.content, shareDescList[res.post.type], getPostShareImg(res.post));
      store.commit('setPageInfo', {
        pageType: pageType(),
        id: res.post.id,
        cid: res.post.channelId,
        title: res.post.content
      });
    }); // 打开话题

    const openTag = tag => {
      if (isIframe.value) {
        return;
      }

      openWebPage('topic/index.html', tag.id);
    }; // 评论完成


    const commentListRef = ref(null);

    const finishComment = () => {
      // 重新获取最新评论
      request.getPostDetail(id).then(res => {
        postItem.value = res.post;
        commentListRef.value.reLoad();
      });
    }; // 页面类型


    const pageType = () => {
      const pageTypeList = {
        ASK: 4,
        MOMENT: 0,
        12345: 6,
        REPORT: 5,
        NEIGHBOR: 9
      };
      return pageTypeList[postItem.value.type];
    }; // [埋点] 页面离开


    const pocPageLeave = type => {
      // const isMini = ua.isMini
      const now = new Date().getTime();
      let _poc_event_params = {
        page_name: '帖子详情页',
        duration: (now - durationStart) / 1000,
        application_type: '佛山+H5',
        content_id: id,
        other_info: postItem.value.memberId,
        type: type
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('public_page_leave', 19999, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('public_page_leave', _poc_event_params);
    };

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      const _component_van_swipe_item = _resolveComponent("van-swipe-item");

      const _component_van_swipe = _resolveComponent("van-swipe");

      return _openBlock(), _createBlock(CPage, {
        model: postItem.value
      }, {
        main: _withCtx(() => [postItem.value.images && postItem.value.images.length > 0 ? (_openBlock(), _createBlock(_component_van_swipe, {
          key: 0,
          class: "photo-wrap"
        }, {
          indicator: _withCtx(({
            active,
            total
          }) => [_createElementVNode("div", _hoisted_1, _toDisplayString(active + 1) + "/" + _toDisplayString(total), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postItem.value.images, (item, index) => {
            return _openBlock(), _createBlock(_component_van_swipe_item, {
              key: 'photo' + index
            }, {
              default: _withCtx(() => [_createVNode(_component_van_image, {
                fit: "contain",
                class: "swipe-img",
                src: item.filePath,
                onClick: _cache[0] || (_cache[0] = $event => _unref(openApp)())
              }, null, 8, ["src"])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true), postItem.value.videos && postItem.value.videos.length > 0 ? (_openBlock(), _createBlock(CPlayer, {
          key: 1,
          postItem: postItem.value
        }, null, 8, ["postItem"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "content-wrap",
          style: _normalizeStyle({
            'padding-bottom': !postItem.value.videos || postItem.value.videos.length == 0 ? '12px' : '0'
          })
        }, [!postItem.value.videos || postItem.value.videos.length == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(CImage), {
          class: "head-pic",
          src: postItem.value.memberPhoto
        }, null, 8, ["src"]), _createElementVNode("p", _hoisted_3, [_createTextVNode(_toDisplayString(postItem.value.memberNickname) + " ", 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatTime)(postItem.value.createTime)), 1)]), postItem.value.type == 'ASK' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(postItem.value.bonusPoints) + "积分", 1)])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "follow-btn",
          onClick: _cache[1] || (_cache[1] = $event => _unref(openApp)())
        }))]), _createElementVNode("div", _hoisted_7, _toDisplayString(postItem.value.content), 1)], 64)) : _createCommentVNode("", true), postItem.value.jumpUrlList && postItem.value.jumpUrlList.length > 0 ? (_openBlock(), _createBlock(LinkView, {
          key: 1,
          list: postItem.value.jumpUrlList
        }, null, 8, ["list"])) : _createCommentVNode("", true), (postItem.value.address || postItem.value.tags && postItem.value.tags.length > 0) && postItem.value.type != 'ASK' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [postItem.value.address && postItem.value.address.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createTextVNode(" " + _toDisplayString(postItem.value.address), 1)])) : _createCommentVNode("", true), postItem.value.type != 'ASK' ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(postItem.value.tags, (tag, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: 'tag' + index,
            onClick: $event => openTag(tag)
          }, [_hoisted_12, _createTextVNode(" " + _toDisplayString(tag.name), 1)], 8, _hoisted_11);
        }), 128)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(AuthorProgressView, {
          postItem: postItem.value
        }, null, 8, ["postItem"]), postItem.value.type == 'ASK' ? (_openBlock(), _createBlock(contentWrap, {
          key: 3,
          item: postItem.value,
          type: "2"
        }, null, 8, ["item"])) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, "全部评论（" + _toDisplayString(postItem.value.commentCount) + "）", 1), _createVNode(CommentType)]), postItem.value.id ? (_openBlock(), _createBlock(CommentList, {
          key: 0,
          ref_key: "commentListRef",
          ref: commentListRef,
          postId: postItem.value.id
        }, null, 8, ["postId"])) : _createCommentVNode("", true)]), !_unref(isIframe) ? (_openBlock(), _createBlock(BottomCommentView, {
          key: 2,
          post: postItem.value,
          onFinishComment: finishComment
        }, null, 8, ["post"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"]);
    };
  }

};